import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class OmsOrderLinkController implements IController {

  internalId: string;
  externalId: string;

  public displayId = undefined;
  public canCopy: boolean;

  /* @ngInject */
  constructor(private splitService: SplitService) {
  }

  $onInit() {
    const displayExternal = this.splitService.getSiteExternalIdConfig();
    this.displayId = !this.externalId ? this.internalId : (displayExternal ? this.externalId : this.internalId);
  }

  $onChanges(changes) {
    if (changes.internalId && !changes.internalId.isFirstChange()) {
      this.$onInit();
    }
    if (changes.externalId && !changes.externalId.isFirstChange()) {
      this.$onInit();
    }
  }
}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderLink', {
    bindings: {
      internalId: '<',
      externalId: '<?',
    },
    template: require('./oms-order-link.html').default,
    controller: OmsOrderLinkController
  });
